import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import "../css/dealer.css";
import "../css/records.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  storeById,
  updateStore,
  deleteStore,
} from "../actions/storeActions.js";
import NotAuthorized from "../components/NotAuthorized";

const StoreScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const getStoreById = useSelector((state) => state.getStoreById);
  const { store } = getStoreById;
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [storeId, setStoreId] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [link, setLink] = useState("");
  const [hours, setHours] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  const updateStoreById = useSelector((state) => state.updateStoreById);
  // const { updatedStore } = updateStoreById;

  // useEffect(() => {
  //   if (updatedStore) {
  //     alert("Store Updated");
  //   }
  // }, [updatedStore]);

  useEffect(() => {
    dispatch(storeById(id));
  }, []);
  useEffect(() => {
    if (store) {
      setName(store.name);
      setPhoneNumber(store.phoneNumber);
      setStoreId(store.storeId);
      setAddress(store.address);
      setCity(store.city);
      setState(store.state);
      setLink(store.link);
      setHours(store.hours);
      setLatitude(store.latitude);
      setLongitude(store.longitude);
    }
  }, [store]);

  const updatehandler = (e) => {
    e.preventDefault();
    const result = dispatch(
      updateStore(
        store._id,
        name,
        phoneNumber,
        storeId,
        address,
        city,
        state,
        link,
        hours,
        latitude,
        longitude
      )
    );
    if (result) {
      alert("Store Updated");
      navigate("/store");
    }
  };
  const deleteHandler = (e) => {
    e.preventDefault();
    const result = dispatch(deleteStore(store._id));
    if (result) {
      alert("Store deleted");
      navigate("/store");
    }
  };

  const adminInfo = useSelector((state) => state.adminInfo);

  const { adminData } = adminInfo;

  useEffect(() => {
    if (adminData) {
      if (adminData.accessLevel === "Viewer") {
        console.log("you're not allowed");
      }
    }
  }, []);

  return (
    <div className="container-fluid ">
      <div className="row ">
        <div className="col-lg-2 p-0">
          <Sidebar active={6} />
        </div>
        <div className="col-lg-10 p-0">
          {adminData && adminData.accessLevel === "Viewer" ? (
            <NotAuthorized />
          ) : (
            <div className="records-page">
              <div className="records-header-row d-flex align-items-center justify-content-between flex-wrap">
                <h4 className="records-heading">Edit Store</h4>
                <div className="d-flex" style={{ gap: "0.75em" }}>
                  <button
                    type="submit"
                    form="edit-store-form"
                    className="btn btn-primary text-light records-action-btn"
                  >
                    <i class="fa-solid fa-check"></i> Save
                  </button>
                  <button
                    onClick={deleteHandler}
                    data-confirm="Are you sure?"
                    className="btn btn-danger text-light records-action-btn"
                  >
                    <i class="fa-solid fa-trash"></i> Delete
                  </button>
                </div>
              </div>
              <div className="form-card">
                <form id="edit-store-form" onSubmit={updatehandler}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="store-name"
                          placeholder="Name"
                          required
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        <label for="store-name">Name</label>
                      </div>
                      <div className="d-flex" style={{ gap: "0.75em" }}>
                        <div className="form-floating mb-3 w-100">
                          <input
                            type="text"
                            class="form-control"
                            id="store-id"
                            placeholder="Store ID"
                            value={storeId}
                            onChange={(e) => setStoreId(e.target.value)}
                          />
                          <label for="store-id">Store ID</label>
                        </div>
                        <div className="form-floating mb-3 w-100">
                          <input
                            type="tel"
                            class="form-control"
                            id="store-phone"
                            placeholder="Mobile Number"
                            required
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                          />
                          <label for="store-phone">Mobile Number</label>
                        </div>
                      </div>

                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="store-address"
                          placeholder="Address"
                          required
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                        <label for="store-address">Address</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex" style={{ gap: "0.75em" }}>
                        <div className="form-floating mb-3 w-100">
                          <input
                            type="text"
                            class="form-control"
                            id="store-city"
                            required
                            placeholder=""
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                          />
                          <label for="store-city">City</label>
                        </div>
                        <div className="form-floating mb-3 w-100">
                          <select
                            class="form-control"
                            required
                            id="store-state"
                            aria-label="Floating label select example"
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                          >
                            <option selected value="">
                              India
                            </option>
                            <option value="Andhra Pradesh">
                              Andhra Pradesh
                            </option>
                            <option value="Arunachal Pradesh">
                              Arunachal Pradesh
                            </option>
                            <option value="Assam">Assam</option>
                            <option value="Bihar">Bihar</option>
                            <option value="Chandigarh">Chandigarh</option>
                            <option value="Chhattisgarh">Chhattisgarh</option>
                            <option value="Dadra & Nagar Haveli">
                              Dadra & Nagar Haveli
                            </option>
                            <option value="Delhi">Delhi</option>
                            <option value="Goa">Goa</option>
                            <option value="Gujarat">Gujarat</option>
                            <option value="Haryana">Haryana</option>
                            <option value="Himachal Pradesh">
                              Himachal Pradesh
                            </option>
                            <option value="Jammu & Kashmir">
                              Jammu & Kashmir
                            </option>
                            <option value="Jharkhand">Jharkhand</option>

                            <option value="Karnataka">Karnataka</option>
                            <option value="Kerala">Kerala</option>
                            <option value="Madhya Pradesh">
                              Madhya Pradesh
                            </option>
                            <option value="Maharashtra">Maharashtra</option>
                            <option value="Manipur">Manipur</option>

                            <option value="Meghalaya">Meghalaya</option>
                            <option value="Mizoram">Mizoram</option>
                            <option value="Nagaland">Nagaland</option>
                            <option value="Orissa">Orissa</option>
                            <option value="Puducherry">Puducherry</option>
                            <option value="Punjab">Punjab</option>

                            <option value="Rajasthan">Rajasthan</option>
                            <option value="Sikkim">Sikkim</option>
                            <option value="Tamil Nadu">Tamil Nadu</option>
                            <option value="Telangana">Telangana</option>
                            <option value="Tripura">Tripura</option>

                            <option value="Uttar Pradesh">Uttar Pradesh</option>
                            <option value="Uttarakhand">Uttarakhand</option>
                            <option value="West Bengal">West Bengal</option>
                          </select>
                          <label for="store-state" className="text-grey">
                            State
                          </label>
                        </div>
                      </div>

                      <div className="form-floating mb-3">
                        <input
                          type="url"
                          class="form-control"
                          required
                          id="store-link"
                          placeholder=""
                          value={link}
                          onChange={(e) => setLink(e.target.value)}
                        />
                        <label for="store-link">Google Maps Link</label>
                      </div>
                      <div className="d-flex" style={{ gap: "0.75em" }}>
                        <div className="form-floating mb-3 w-100">
                          <input
                            type="text"
                            class="form-control"
                            id="store-hours"
                            placeholder="10:00AM to 08:00PM"
                            value={hours}
                            onChange={(e) => setHours(e.target.value)}
                          />
                          <label for="store-hours">Hours</label>
                        </div>
                        <div className="form-floating mb-3 w-100">
                          <input
                            type="text"
                            class="form-control"
                            id="store-lat"
                            required
                            placeholder=""
                            value={latitude}
                            onChange={(e) => setLatitude(e.target.value)}
                          />
                          <label for="store-lat">Latitude</label>
                        </div>
                        <div className="form-floating mb-3 w-100">
                          <input
                            type="text"
                            class="form-control"
                            id="store-lng"
                            required
                            placeholder=""
                            value={longitude}
                            onChange={(e) => setLongitude(e.target.value)}
                          />
                          <label for="store-lng">Longitude</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoreScreen;
